import { Stack, StackProps } from "@mui/material";
import { DragEvent, useState } from "react";

export interface DropBoxProps extends StackProps {

}

export default function DropBox({
    children,
    ...props
}: DropBoxProps) {
    const [hover, setHover] = useState(false);

    const preventDefault = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
    }

    return <Stack
        {...props}
        component={"div"}

        onDragEnter={e => {
            preventDefault(e);
            setHover(true);
        }}
        onDragOver={preventDefault}
        onDragLeave={e => {
            preventDefault(e);
            setHover(false);
        }}
        onDrop={e => {
            preventDefault(e);
            props.onDrop && props.onDrop(e);
            setHover(false);
        }}

        padding={4}
        gap={2}
        sx={{
            borderStyle: "dashed",
            borderWidth: "2px",
            borderRadius: "10px",
            borderColor: "divider",
            backgroundColor: hover ? "action.hover" : "",
            ...props.sx
        }}

        alignItems={"center"}
        justifyContent={"center"}
    >
        {children}
    </Stack>
}